export const selectFunctions = state => state.functions;
